import SolicitaCreditoNew from './SolicitaCreditoNew';
export default SolicitaCreditoNew;
